<script>
export default {
  methods: {},
  props: [],
  data: function () {
    return {};
  },
  computed: {},
};
</script>
    
<template>
  <div class="f-description">
    <slot></slot>
  </div>
</template>

<style lang="scss">
.f-description {
  font-size: 12px;
  font-family: Lato;
  color: #161615;
  font-weight: 400;
}
.dark-mode {
  .f-description {
    color: var(--white-a50);
  }
}
</style>